import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const scrollToTop = () => {
  const lenis = window.__lenis;
  if (lenis) {
    lenis.stop();
    lenis.scrollTo(0, { immediate: true, force: true });
    lenis.start();
  }
  window.scrollTo(0, 0);
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

export const scrollToId = (id, immediate = false) => {
  const el = document.getElementById(id);
  if (!el) return false;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -80, immediate, force: immediate });
  else el.scrollIntoView({ behavior: immediate ? "auto" : "smooth" });
  return true;
};

export default function RouteScroll() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if ("scrollRestoration" in window.history) window.history.scrollRestoration = "manual";
  }, []);
  useEffect(() => {
    if (hash) {
      const id = hash.slice(1);
      let tries = 0;
      const tick = () => {
        if (scrollToId(id, true)) {
          setTimeout(() => scrollToId(id, true), 500);
          setTimeout(() => scrollToId(id, true), 1200);
        } else if (tries++ < 20) setTimeout(tick, 100);
      };
      tick();
    } else {
      scrollToTop();
      requestAnimationFrame(scrollToTop);
      const timers = [120, 350].map((ms) => setTimeout(scrollToTop, ms));
      return () => timers.forEach(clearTimeout);
    }
  }, [pathname, hash]);
  return null;
}
